import React from 'react';
import styled from 'astroturf/react';

import { User } from 'js/liswp/Sidebar/hooks/types';
import _Avatar from "UserAvatar-Avatar.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserAvatar.tsx?styleId=Avatar";


const PLACEHOLDER_PHOTO = '//a.academia-assets.com/images/s65_no_pic.png';

const Avatar = /*#__PURE__*/styled("img", null, {
  displayName: "Avatar",
  styles: _Avatar
});

type Props = {
  user: User;
  small?: boolean;
};

const UserAvatar: React.FC<Props> = ({ user, small }) => (
  <Avatar
    src={user.photo || PLACEHOLDER_PHOTO}
    width={small ? 40 : 48}
    height={small ? 40 : 48}
  />
);

export default UserAvatar;
